module.exports = __webpack_public_path__ + "img/1-1.67f08f7f.png";